export default {
	MoveOrder: {
		id: 'MoveOrder',
		label: '调拨单',
		selectedList: [],
		mistakeCheckList: [
			{
				id: 'ZeroAmount',
				title: '申请数量为0',
				mistakeType: 'error'
			}, {
				id: 'Belong',
				title: '仓库与品项关联关系',
				mistakeType: 'error'
			}, {
				id: 'Repeat',
				title: '重复品项',
				mistakeType: 'warn'
			}
		]
	}
}
